<mat-card class="mat-card-inline-sm">
  <mat-card-content fxLayout="column">
    <div class="mat-card-content-label w-100" fxLayout="row" fxLayoutAlign="space-between center">
      <label>Last 10 <span *ngIf="!scratchOnly && productTypeFilter !== undefined" [ngStyle]="{ 'color': getProductColour(productTypeFilter) }">{{ productTypes[productTypeFilter] }}</span><span *ngIf="scratchOnly" class="scratch-label">Scratch</span></label>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
        <ng-container *ngIf="product === productTypes.Facade">
          <mat-icon [class.link]="productTypeFilter !== productTypes.Facade" 
            [class.disable-link]="productTypeFilter === productTypes.Facade"
            matTooltip="Showing Facade"
            (click)="setProductFilter(productTypes.Facade)"
            [style.color]="getProductColour(productTypes.Facade)">image</mat-icon>
        </ng-container>
        <ng-container *ngIf="product !== productTypes.Facade">
          <mat-icon [class.link]="productTypeFilter !== productTypes.Panorama" 
            [class.disable-link]="productTypeFilter === productTypes.Panorama" 
            [matTooltip]="productTypeFilter === productTypes.Panorama ? 'Showing ' + productTypes[productTypes.Panorama] : 'Show ' + productTypes[productTypes.Panorama]" 
            (click)="setProductFilter(productTypes.Panorama)"
            [style.color]="getProductColour(productTypes.Panorama)">panorama</mat-icon>
          <mat-icon [class.link]="productTypeFilter !== productTypes.RayTracedDraft"
            [class.disable-link]="productTypeFilter === productTypes.RayTracedDraft"
            [matTooltip]="productTypeFilter === productTypes.RayTracedDraft ? 'Showing ' + productTypes[productTypes.RayTracedDraft] : 'Show ' + productTypes[productTypes.RayTracedDraft]"
            (click)="setProductFilter(productTypes.RayTracedDraft)"
            [style.color]="getProductColour(productTypes.RayTracedDraft)">panorama</mat-icon>
          <mat-icon [class.link]="productTypeFilter !== productTypes.RayTraced"
            [class.disable-link]="productTypeFilter === productTypes.RayTraced"
            [matTooltip]="productTypeFilter === productTypes.RayTraced ? 'Showing ' + productTypes[productTypes.RayTraced] : 'Show ' + productTypes[productTypes.RayTraced]" 
            (click)="setProductFilter(productTypes.RayTraced)"
            [style.color]="getProductColour(productTypes.RayTraced)">panorama</mat-icon>
          <mat-icon [class.link]="productTypeFilter !== productTypes.RayTracedPlus" 
            [class.disable-link]="productTypeFilter === productTypes.RayTracedPlus" 
            [matTooltip]="productTypeFilter === productTypes.RayTracedPlus ? 'Showing ' + productTypes[productTypes.RayTracedPlus] : 'Show ' + productTypes[productTypes.RayTracedPlus]" 
            (click)="setProductFilter(productTypes.RayTracedPlus)"
            [style.color]="getProductColour(productTypes.RayTracedPlus)">panorama</mat-icon>
          <mat-icon [class.link]="productTypeFilter !== productTypes.Plan" 
            [class.disable-link]="productTypeFilter === productTypes.Plan" 
            [matTooltip]="productTypeFilter === productTypes.Plan ? 'Showing ' + productTypes[productTypes.Plan] : 'Show ' + productTypes[productTypes.Plan]" 
            (click)="setProductFilter(productTypes.Plan)"
            [style.color]="getProductColour(productTypes.Plan)">foundation</mat-icon>
          <mat-icon [class.link]="productTypeFilter !== productTypes.Render" 
            [class.disable-link]="productTypeFilter === productTypes.Render" 
            [matTooltip]="productTypeFilter === productTypes.Render ? 'Showing ' + productTypes[productTypes.Render] : 'Show ' + productTypes[productTypes.Panorama]" 
            (click)="setProductFilter(productTypes.Render)"
            [style.color]="getProductColour(productTypes.Render)">photo_camera</mat-icon>
        </ng-container>
        <mat-icon [class.link]="!userFilter" [class.disable-link]="userFilter"
          [matTooltip]="userFilter ? 'Show all Creations' : 'Show my Creations'"
          (click)="toggleUserFilter()"
          color="accent">person</mat-icon>
        <mat-icon *ngIf="isSituUser" [class.link]="!scratchOnly" [class.disable-link]="scratchOnly"
          [matTooltip]="scratchOnly ? 'Hide scratch renders' : 'Show scratch renders only'"
          (click)="toggleScratchFilter()"
          color="accent">science</mat-icon>
        <mat-icon *ngIf="isReleaseUser" [class.link]="!bugTracking" [class.disable-link]="bugTracking"
        [matTooltip]="bugTracking ? 'Hide release issues' : 'Show release issues'" 
          (click)="toggleIssueFilter()"
          color="primary">bug_report</mat-icon>
      </div>
    </div>
    <mat-form-field *ngIf="!bugTracking" appearance="outline" class="w-100 home-filter">
      <mat-select [value]="homeFilter ?? ''" (openedChange)="onHomesOpened($event)" (selectionChange)="setHomeFilter($event.value)" aria-label="Home">
        <mat-option value="">All homes</mat-option>
        <mat-option *ngFor="let h of homeOptions" [value]="h.homeId">{{ h.name }}<span class="count" *ngIf="h.count"> · {{ h.count }}</span></mat-option>
        <mat-option *ngIf="homesLoading" disabled>Loading homes…</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <div *ngIf="filter?.type && filter?.value" fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="4px">
      <small>{{ filter?.type }} filter: </small><small><span class="highlight">{{ filter?.value }}</span></small><mat-icon (click)="clearFilter()" class="font-14 link mini-icon">clear</mat-icon>
    </div> -->
    <ng-container *ngIf="!bugTracking">
      <ng-container *ngIf="listType === renderedOutputStatus.Complete">
        <ng-container *ngFor="let item of completeConfigs">
          <home-config-list-card [canView]="true" [canCompare]="true" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [renderedOutput]="item"
            [renderedOutputId]="viewRenderedOutput?.id"
            [comparisonRenderedOutputId]="compareRenderedOutput?.id"
            (selectedRenderedOutputId)="select($event)"
            (selectedComparisonRenderedOutputId)="selectForComparison($event)">
          </home-config-list-card>
        </ng-container>
        <ng-container *ngIf="completeConfigs?.length < 1">
          <mat-card class="mat-card-inline-sm contrast">
            <mat-card-content *ngIf="homeFilter">
              No renders of this home match the current filters.
            </mat-card-content>
            <mat-card-content *ngIf="!homeFilter && scratchOnly">
              No scratch renders yet — render one from the scratch pad in advanced mode.
            </mat-card-content>
            <mat-card-content *ngIf="!homeFilter && !scratchOnly && product === productTypes.Panorama">
              Create a <span [style.color]="getProductColour(productTypes.Panorama)">situVIEW</span> to get started!
            </mat-card-content>
            <mat-card-content *ngIf="!homeFilter && !scratchOnly && product === productTypes.Facade">
              Create a <span [style.color]="getProductColour(productTypes.Facade)">situFACADE</span> to get started!
            </mat-card-content>
          </mat-card>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="listType === renderedOutputStatus.InProgress">
        <ng-container *ngFor="let item of recentConfigs">
          <home-config-list-card [canView]="true" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [renderedOutput]="item"
            (selectedRenderedOutputId)="select($event)"
            (selectedComparisonRenderedOutputId)="selectForComparison($event)">
          </home-config-list-card>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="listType === renderedOutputStatus.Queued">
        <ng-container *ngFor="let item of queuedConfigs">
          <home-config-list-card [canView]="true" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [renderedOutput]="item"
            (selectedRenderedOutputId)="select($event)"
            (selectedComparisonRenderedOutputId)="selectForComparison($event)">
          </home-config-list-card>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="listType === renderedOutputStatus.Failed">
        <ng-container *ngFor="let item of failedConfigs">
          <home-config-list-card [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [renderedOutput]="item" [isFailed]="true">
          </home-config-list-card>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="bugTracking">
      <release-issue-list [companyId]="selectedCompany?.id" [productName]="product" (onIssueSelectClick)="onIssueSelect($event)">
      </release-issue-list>
    </ng-container>
  </mat-card-content>
</mat-card>